require 'angular'
app = angular.module('workflow.app')

require('./Partials/ManualStepModal')
require('./Partials/ServerSideConfirmCompletionModal')
require('./Partials/StepCompletionRequiredModal')
require('./Custom')
require('./Search')
require('./Findings')
require('./SupportThread')

app.controller('ProjectStepController', require './ProjectStepController')
